import { Module } from 'vuex';

import actions from './actions';
import getters from './getters';
import state, { StateType } from './state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const storeModule: Module<StateType, any> = {
  namespaced: true,
  getters,
  actions,
  state,
};

export default storeModule;